import type { GameTheme } from "./types.js";

export interface ThemeInfo {
  key: GameTheme;
  /** User-facing label (European Portuguese). */
  label: string;
  /** Emoji shown beside the theme in the picker. */
  icon: string;
}

/**
 * Fixed list of themes for the emoji game (IDEA-025 v1). Single source of truth.
 * Add a theme by adding a line here (and to VALID_THEMES in validation.ts).
 */
export const THEMES: Record<GameTheme, ThemeInfo> = {
  paises: { key: "paises", label: "Países", icon: "🌍" },
  profissoes: { key: "profissoes", label: "Profissões", icon: "💼" },
  filmes: { key: "filmes", label: "Filmes", icon: "🎬" },
  musica: { key: "musica", label: "Música", icon: "🎵" },
  nos: { key: "nos", label: "Nós", icon: "💑" },
  lugares: { key: "lugares", label: "Lugares", icon: "🏞️" },
  comida: { key: "comida", label: "Comida", icon: "🍕" },
  celebracoes: { key: "celebracoes", label: "Celebrações", icon: "🎉" },
  hobbies: { key: "hobbies", label: "Hobbies", icon: "🎮" },
  marcas: { key: "marcas", label: "Marcas", icon: "📺" },
  personagens: { key: "personagens", label: "Personagens", icon: "🦸" },
  desporto: { key: "desporto", label: "Desporto", icon: "⚽" },
};

/** Ordered list, handy for the theme select. */
export const THEME_LIST: ThemeInfo[] = Object.values(THEMES);

export function themeInfo(theme: GameTheme): ThemeInfo {
  return THEMES[theme];
}
